"use strict";
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var constants_1 = require("../../constants");
var useRowHeight = function (isDynamicRowHeight, cellMeasurerCache, rowHeight) {
    if (rowHeight === void 0) { rowHeight = constants_1.ROW_HEIGHT; }
    var value = (0, react_1.useMemo)(function () { return (isDynamicRowHeight ? cellMeasurerCache.rowHeight : rowHeight); }, [cellMeasurerCache.rowHeight, isDynamicRowHeight, rowHeight]);
    return value;
};
exports.default = useRowHeight;
